"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAdAnalyticsPlacement = void 0;
const AdAnalyticsPlacementTypes_1 = require("../../entity/AdAnalyticsPlacementTypes");
const createAdAnalyticsPlacement = () => AdAnalyticsPlacementTypes_1.AdAnalyticsPlacement.fromJSON({
    key: 'all_placements',
    name: '',
});
exports.createAdAnalyticsPlacement = createAdAnalyticsPlacement;
